import { render, staticRenderFns } from "./cutomAnalysis.vue?vue&type=template&id=6654d12a&scoped=true&"
import script from "./cutomAnalysis.vue?vue&type=script&lang=js&"
export * from "./cutomAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./cutomAnalysis.vue?vue&type=style&index=0&id=6654d12a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654d12a",
  null
  
)

export default component.exports